import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavRightComponent } from './header-right/header-right.component';
import { NavLeftComponent } from './header-left/header-left.component';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NavLeftComponent, NavRightComponent, MatToolbarModule],
  template: `
    <mat-toolbar class="nav-bar">
      <div class="nav-bar__wrapper">
        <app-header-left></app-header-left>
        <app-header-right></app-header-right>
      </div>
    </mat-toolbar>
  `,
  styles: [
    `
      :host {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1025;
      }

      .nav-bar {
        backdrop-filter: blur(7px);
        box-shadow: none;

        &__wrapper {
          backdrop-filter: blur(7px);
          background-color: var(--accent-100) !important;
          box-shadow: none;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 25px;
          width: 100%;
          height: 64px;
        }
      }

      :host-context(.dark-theme) .nav-bar {
        background-color: rgba(40, 40, 40, 0.8);
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavBarComponent {
}
